import { ResultReadyStates, State } from '@/features/single-measurement/types';

export const isResultReady = (state?: State) => {
  return state ? ResultReadyStates.includes(state) : false;
};
